import { Link } from 'react-router';
import type { PostImage } from '../../lib/communities';

/**
 * A post's pictures: one shown whole, several as a grid of squares (from the small size). In
 * the feed they open the post (`to`); on the post page each opens full size in a new tab.
 */
export function PostImages({
  images,
  author,
  to,
}: {
  images: PostImage[];
  author: string;
  to?: string;
}) {
  if (!images.length) return null;
  const single = images.length === 1;
  const alt = (i: number) =>
    single ? `Shared by ${author}` : `${i + 1} of ${images.length}, shared by ${author}`;

  return (
    <div className={single ? '' : 'grid grid-cols-2 gap-1.5'}>
      {images.map((image, i) => {
        const picture = (
          <img
            key={image.id}
            src={single ? image.url : image.thumbUrl}
            alt={alt(i)}
            width={image.width}
            height={image.height}
            loading="lazy"
            className={
              single
                ? 'max-h-[520px] w-full rounded-2xl bg-field object-contain'
                : 'aspect-square w-full rounded-xl bg-field object-cover'
            }
          />
        );
        const frame = `block overflow-hidden ${single ? 'rounded-2xl' : 'rounded-xl'}`;
        return to ? (
          <Link key={image.id} to={to} className={frame}>
            {picture}
          </Link>
        ) : (
          <a
            key={image.id}
            href={image.url}
            target="_blank"
            rel="noopener noreferrer"
            className={frame}
          >
            {picture}
          </a>
        );
      })}
    </div>
  );
}
